import LayerDataHandlerListenerKeys from "./lov/LayerDataHandlerListenerKeys";
import FeatureLayerWorkerTileSource from "./source/FeatureLayerWorkerTileSource";
import EventType from "./events/EventType";

import StyleFactory from "./StyleFactory";

import { listen, unlistenByKey } from 'ol/events.js';


//===============================================================================================
// Constructor
//===============================================================================================

/**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @constructor
 * @param {geocloud.layerDefinition} layerDefinition Geocloud dynamic layer definition.
 */
var LayerDataHandler = function (layerDefinition, sessionKey, apiUrl) {
  this._layerDef = layerDefinition;
  this._sessionKey = sessionKey;
  this._apiUrl = apiUrl;

  this._visible = false;
  this._gridVisible = false;
  this._active = false;
  this._searchText = '';
  this._filteredColumns = [];
  this._theme = null;

  this._listeners = {};

  

  this._source = new FeatureLayerWorkerTileSource();

  var styles = this._layerDef.styles.map(x => StyleFactory.loadStyle(x.value));
  this._source.setStyle(styles); //set multiple styles per style classification

  this._selectionChangeKey = listen(this._source, EventType.SELECTION_CHANGE, this._handleSourceEvents, this);


  //loop breaker
  this._dispatchingUpdateData = false;
}





//===============================================================================================
// Property Methods
//===============================================================================================

LayerDataHandler.prototype.layerDefinition = function () {
  return this._layerDef;
}

LayerDataHandler.prototype.setLayerDefinition = function (value) {

  if (!value || value.id !== this._layerDef.id) {
    console.error('setLayerDefinition invalid value', {currValue:this._layerDef, newValue:value});
    return;
  }

  if (value.epochstamp === this._layerDef.epochstamp) {
    return;
  }

  this._layerDef = value;

  //var styles = this._layerDef.styles.map(x => StyleFactory.loadStyle(x.value));
  //this._source.setStyle(styles); //set multiple styles per style classification
  this.setStyles(this._layerDef.styles);

  this.dispatch(LayerDataHandlerListenerKeys.LAYER_DEFINITION_CHANGED, [this._layerDef]);
}

LayerDataHandler.prototype.setStyles = function (value) {
  if (!value || !Array.isArray(value)) {
    console.error('setStyles invalid value', {newValue:value});
    return;
  }

  var styles = value.map(x => StyleFactory.loadStyle(x.value));
  this._source.setStyle(styles); //set multiple styles per style classification
}


LayerDataHandler.prototype.visible = function () {
  return this._visible;
}

LayerDataHandler.prototype.setVisible = function (value) {
  if (!!value === this._visible)
    return;

  this._visible = !!value;

  this.dispatch(LayerDataHandlerListenerKeys.VISIBLE_CHANGED, [this._visible]);

  if (this._source.visible() !== value) {
    throw new Error('Source não teve visibilidade alterada para "'+ this._visible + '"');
  }

}


LayerDataHandler.prototype.gridVisible = function () {
  return this._gridVisible;
}

LayerDataHandler.prototype.setGridVisible = function (value) {
  if (!!value === this._gridVisible)
    return;

  this._gridVisible = !!value;

  this.dispatch(LayerDataHandlerListenerKeys.GRID_VISIBLE_CHANGED, [this._gridVisible]);
}


LayerDataHandler.prototype.active = function () {
  return this._active;
}

LayerDataHandler.prototype.setActive = function (value) {
  if (!!value === this._active)
    return;

  this._active = !!value;

  this.dispatch(LayerDataHandlerListenerKeys.ACTIVE_CHANGED, [this._active]);
}


LayerDataHandler.prototype.searchText = function () {
  return this._searchText;
}

LayerDataHandler.prototype.setSearchText = function (value) {
  if (value === this._searchText)
    return;

  this._searchText = value;

  this.dispatch(LayerDataHandlerListenerKeys.SEARCH_TEXT_CHANGED, [this._searchText]);
}


LayerDataHandler.prototype.theme = function () {
  return this._theme;
}

LayerDataHandler.prototype.setTheme = function (value) {
  if (value === this._theme)
    return;

  this._theme = value;

  this.dispatch(LayerDataHandlerListenerKeys.THEME_CHANGED, [this._theme]);
}


LayerDataHandler.prototype.filteredColumns = function () {
  return JSON.parse(JSON.stringify(this._filteredColumns));
}

LayerDataHandler.prototype.setFilteredColumns = function (value) {
  value = value || [];

  var valueStr = JSON.stringify(value)
  this._filteredColumns = JSON.parse(valueStr);

  this.dispatch(LayerDataHandlerListenerKeys.FILTERED_COLUMNS_CHANGED, [JSON.parse(valueStr)]);
}

LayerDataHandler.prototype.source = function () {
  return this._source;
}





//===============================================================================================
// Data Methods
//===============================================================================================

LayerDataHandler.prototype.dispose = function () {
  if (this._selectionChangeKey) {
    unlistenByKey(this._selectionChangeKey);
    this._selectionChangeKey = null;
  }

  this.dispatch(LayerDataHandlerListenerKeys.DISPOSE_REQUESTED);
}

LayerDataHandler.prototype.stopDataRequests = function () {
  this._source.stopDataRequests();
}

LayerDataHandler.prototype.updateData = function (successCallback, errorCallback) {
  if (this._dispatchingUpdateData){
    //console.log("Combo breaker");
    return;
  }

  if (!this.visible() && !this.gridVisible())
    return;

  //console.log("Call", this._layerDef.id);

  this._dispatchingUpdateData = true;

  if (!this._source.initialized())
    this._source.initialize(this._layerDef.id, this._layerDef.epochstamp, this._layerDef.geomType, this._sessionKey, this._apiUrl);

  if (this.visible())
    this._source.updateData(this._layerDef.epochstamp, this._searchText, this._filteredColumns, this._theme, successCallback, errorCallback);

  
  this.dispatch(LayerDataHandlerListenerKeys.UPDATE_REQUESTED);

  this._dispatchingUpdateData = false;
}

LayerDataHandler.prototype.clearData = function () {
  this._source.clearData();
}

LayerDataHandler.prototype.select = function (idList) {
  if (!this._source.initialized())
    this._source.initialize(this._layerDef.id, this._layerDef.epochstamp, this._layerDef.geomType, this._sessionKey, this._apiUrl);

  this._source.select(idList);
}

LayerDataHandler.prototype.deselect = function (idList) {
  if (this._source.initialized())
    this._source.deselect(idList);
}

//LayerDataHandler.prototype.changeSelection = function (idList) {
  
//}

LayerDataHandler.prototype.clearSelection = function () {
  this._source.clearSelection();
}

LayerDataHandler.prototype.getSelectedIds = function (idList, callback) {
  if (!this._source.initialized())
    callback([]);

  this._source.getSelectedIds(idList, callback);
}




LayerDataHandler.prototype._handleSourceEvents = function (event) {

  switch (event.type) {

    case EventType.SELECTION_CHANGE:
      this.dispatch(LayerDataHandlerListenerKeys.SELECTION_CHANGED);
      break;

    default:
      throw new Error('Not Implemented!');
  }


  // var currentToken = ++this._refreshToken;

  // setTimeout(() => {
  //   if (this._refreshToken !== currentToken)
  //     return;

  //   this.dispatchEvent(EventType.CLEAR);

  //   this.tileCache.clear();
  //   this.changed();
  // }, 100);
};





//===============================================================================================
// Dispatch Methods
//===============================================================================================


LayerDataHandler.prototype.dispatch = function (key, params) {
  const error = _formatError([this._layerDef.id, 'dispatch', key]);

  _validateKey(key, error);
  _validateParams(params, error);

  if (!this._listeners[key] || this._listeners[key].length === 0) {
    console.error(`${ error }: No listeners!`)
    return null;
  }

  params = params || [];
  params.unshift(this);

  this._listeners[key].forEach(f => {
    f.apply(null, params);
  });
}

LayerDataHandler.prototype.call = function (key, params) {
  const error = _formatError([this._layerDef.id, 'call', key]);

  _validateKey(key, error);
  _validateParams(params, error);

  if (!this._listeners[key] || this._listeners[key].length === 0) {
    console.error(`${ error }: No listeners!`)
    return null;
  }

  params = params || [];
  params.unshift(this);
  
  return this._listeners[key][0].apply(null, params);
}

LayerDataHandler.prototype.addListener = function (key, callback) {
  const error = _formatError([this._layerDef.id, 'addListener', key]);

  _validateKey(key, error);
  _validateCallback(callback, error);

  if (!this._listeners[key])
    this._listeners[key] = [callback];
  else {
    var idx = this._listeners[key].indexOf(callback);

    if (idx<0)
      this._listeners[key].push(callback);
  }
}

LayerDataHandler.prototype.removeListener = function (key, callback) {
  const error = _formatError([this._layerDef.id, 'removeListener', key]);

  _validateKey(key, error);
  _validateCallback(callback, error);

  if (!this._listeners[key])
    return;

  var idx = this._listeners[key].indexOf(callback);

  if (idx>=0)
    this._listeners[key].splice(idx, 1);
}






//===============================================================================================
// Utilitary
//===============================================================================================
var _formatError = function (errorParams) {
  return `LayerDataHandler[Id="${ errorParams[0] }"].${errorParams[1]}[key="${ errorParams[2] }"]`;
}


var _validateKey = function (value, error) {
  if ('string' !== typeof value || value === "" || value !== value.toLowerCase())
    throw new Error(`${ error }: key must be a lower case string!`);
}

var _validateCallback = function (value, error) {
  if ('function' !== typeof value)
    throw new Error(`${ error }: callback must be a function!`);
}

var _validateParams = function (value, error) {
  if (value !== undefined && value !== null && !Array.isArray(value))
    throw new Error(`${ error }: params must be an array!`);
}








export default LayerDataHandler;